import { useSelector } from 'react-redux';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import { RootState } from 'redux/store';
import { downloadQR } from 'redux/slices/qr/qrCodeSlice';
import CardWrapper from 'components/Common/CardWrapper';
import { useLocation } from 'react-router-dom';
import QRCode from 'react-qr-code';
import { APP_PROTOCOL, QR_BASE_URL } from '../../../src/config/apiConfig';
import { useMemo } from 'react';

const QRCodeGenerator = () => {
    const location = useLocation() || {};
    const { showButton } = location?.state || {};
    const userInfo = useSelector((state: RootState) => state.user?.userInfo);
    const { businessName, nickname } = userInfo || {};
    const handleDownloadQR = () => {
        downloadQR('qrcode', 'OGP_Portal');
    };

    const buildQRString = useMemo((): string => {
        const baseUrl = `${QR_BASE_URL}/?app_protocol=${APP_PROTOCOL}://sendPayment`;
        const params = new URLSearchParams({
            shoppingCartId: '',
            merchantId: nickname || '',
            amount: '0.0',
            ref: 'MERCHANT',
        });

        return `${baseUrl}&${params.toString()}`;
    }, []);

    return (
        <>
            <CardWrapper hideButton={!showButton}>
                {!showButton && (
                    <Stack direction="row" alignItems="center" justifyContent={'right'}>
                        <IconButton size="large" onClick={handleDownloadQR}>
                            <SaveAltIcon sx={{ fontSize: 40, color: 'black' }} />
                        </IconButton>
                    </Stack>
                )}
                <Stack alignItems="center" mb={5}>
                    <Box display={'flex'} flexDirection={'column'} alignItems={'center'} mb={5}>
                        <Typography sx={{ fontSize: 32 }} variant="h6" mb={-1}>
                            {businessName}
                        </Typography>
                        <Typography sx={{ fontSize: 22 }} variant="h5">
                            {nickname}
                        </Typography>
                    </Box>
                    <QRCode id="qrcode" value={buildQRString} size={400} level="H" />
                </Stack>
            </CardWrapper>
        </>
    );
};

export default QRCodeGenerator;
